import styled, { x } from '@xstyled/styled-components'
import { th } from '@xstyled/system'

export const DropdownContentWrap = styled(x.div)`
  width: 180px;
  background-color: white;
  box-shadow: dropShadow;
  padding: 8px;
  color: gray1;
  border: 1px solid ${th.color('lightGray6')};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const DropdownPositionWrap = styled(x.div)`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
`

export const OptionItem = styled(x.div)<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  background-color: ${({ $active, theme }) => ($active ? theme.colors.bgLightGray1 : 'transparent')};
  color: ${({ $active, theme }) => ($active ? theme.colors.blue3 : theme.colors.typoPrimary)};

  &:hover {
    background-color: ${({ theme }) => theme.colors.bgLightGray1};
    color: ${({ theme }) => theme.colors.blue3};
  }
`

export const IconWrap = styled(x.div)`
  width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`
